import { FileUploader, FileUploaderProps } from "@q4/nimbus-ui";
import React from "react";
import { usePreloadCanvasImg } from "../../hooks/usePreloadCanvasImg/usePreloadCanvasImg.hook";

export const FileUploaderWithImgPreload = (props: FileUploaderProps): JSX.Element => {
  const fileUrl = usePreloadCanvasImg(props.fileUrl);
  return <FileUploader {...props} fileUrl={fileUrl} />;
};
